export const getMaxInviteesInitialValue = ({ invitees_limit: inviteesLimit }) => ({
  inviteesLimit: inviteesLimit?.toString() || '2',
})
